/**
 * "Your Ellie chat link was opened" pushes. The backend sends them when a guest
 * spends a view on a link the reader shared (projects/controllers/guest-links/
 * open) with `type: 'guest_link_opened'`, the plan and the conversation the
 * guest was invited into. A tap opens that conversation through the same path
 * as a conversation-invite link: RootNavigator's queueProjectChat on native,
 * projectChatNavigationTarget from DesktopLayout on web.
 */
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const GUEST_LINK_OPENED = 'guest_link_opened';

/** The conversation a guest-link push points at, or null for any other push. */
export function guestLinkOpenedTarget(data: unknown): { projectId: number; conversationId: string } | null {
  if (!data || typeof data !== 'object') return null;
  const d = data as Record<string, unknown>;
  if (d.type !== GUEST_LINK_OPENED) return null;
  const projectId = Number(d.project_id);
  const conversationId = typeof d.conversation_id === 'string' ? d.conversation_id.trim() : '';
  if (!Number.isInteger(projectId) || projectId <= 0 || !UUID_RE.test(conversationId)) return null;
  return { projectId, conversationId: conversationId.toLowerCase() };
}
